module.exports = __webpack_public_path__ + "img/equity_icon10.1178faab.png";